import { Instagram } from "lucide-react";

export const INSTAGRAM_URL = "https://www.instagram.com/dashaloveofficial/";

export function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="w-full bg-black py-2.5 text-center text-[10px] uppercase tracking-[0.3em] ff-sans gold-text"
    >
      ✦ Limited Time — $97 a Bottle (Reg. $127) ✦ Buy 2 • Get 1 Free ✦
    </div>
  );
}

export function StickyCTA() {
  const scrollToOffer = () => {
    document.getElementById("offer")?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="pink-line-top fixed inset-x-0 bottom-0 z-50 border-t border-white/10 bg-black/60 backdrop-blur-2xl md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="flex items-center justify-between gap-3 px-5 py-3">
        <div>
          <p className="ff-serif text-sm tracking-[0.15em] gold-text">PLEASURE PORTAL™</p>
          <p className="text-[10px] uppercase tracking-[0.2em] text-[#f7e7ce]/70 ff-sans">
            $97 <span className="text-[#ff7fbf]">or 3 for $222</span>
          </p>
        </div>
        <button
          data-testid="sticky-shop-now-btn"
          aria-label="Shop now — scroll to offers"
          onClick={scrollToOffer}
          className="btn-gold px-6 py-3 text-[10px] font-semibold uppercase tracking-[0.25em] ff-sans"
        >
          Shop Now
        </button>
      </div>
    </div>
  );
}

export function Footer() {
  const links = [
    { label: "Instagram", href: INSTAGRAM_URL, external: true, testid: "footer-instagram-link" },
    { label: "Contact", href: "#contact", testid: "footer-contact-link" },
    { label: "Shipping", href: "#", testid: "footer-shipping-link" },
    { label: "Returns", href: "#", testid: "footer-returns-link" },
    { label: "Privacy Policy", href: "#", testid: "footer-privacy-link" },
    { label: "Terms", href: "#", testid: "footer-terms-link" },
    { label: "Disclaimer", href: "#", testid: "footer-disclaimer-link" },
  ];
  return (
    <footer data-testid="footer" className="border-t hairline-gold bg-black px-6 pb-32 pt-16 md:pb-16">
      <div className="mx-auto max-w-5xl text-center">
        <p className="ff-serif text-3xl font-light tracking-[0.1em] gold-text">PLEASURE PORTAL™</p>
        <p className="mt-2 text-[10px] uppercase tracking-[0.35em] text-[#f7e7ce]/60 ff-sans">
          Pleasure • Presence • Connection
        </p>
        <nav className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3" aria-label="Footer">
          {links.map((l) => (
            <a
              key={l.label}
              data-testid={l.testid}
              href={l.href}
              {...(l.external ? { target: "_blank", rel: "noopener noreferrer" } : {})}
              className="text-[11px] uppercase tracking-[0.25em] text-[#f7e7ce]/60 transition-colors duration-300 hover:text-[#d4af37] ff-sans"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <div className="mx-auto mt-12 max-w-3xl space-y-4 text-left text-[11px] leading-relaxed text-[#f7e7ce]/45 ff-sans">
          <p data-testid="footer-usage-disclaimer">
            For external use only unless finalized product labeling specifically states otherwise. Use only as
            directed. Avoid contact with eyes and irritated or broken skin. Discontinue use if irritation occurs.
            Keep out of reach of children. Consult an appropriate healthcare professional regarding pregnancy,
            breastfeeding, allergies, medications or medical concerns.
          </p>
          <p data-testid="footer-wellness-disclaimer">
            Statements on this website are for general wellness and educational purposes and are not intended to
            diagnose, treat, cure or prevent disease.
          </p>
          <p data-testid="footer-privacy-disclaimer">
            We use Stripe for payment, analytics, and other business services. Stripe collects identifying
            information about the devices that connect to its services. Stripe uses this information to operate and
            improve the services it provides to us, including for fraud detection. You can learn more about Stripe
            and read its privacy policy at https://stripe.com/privacy.
          </p>
        </div>
        <div className="mt-10 flex items-center justify-center gap-2 text-[#f7e7ce]/40">
          <Instagram size={13} strokeWidth={1.5} />
          <a
            data-testid="footer-instagram-handle"
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[11px] tracking-[0.2em] ff-sans hover:text-[#d4af37] transition-colors duration-300"
          >
            @dashaloveofficial
          </a>
        </div>
        <p className="mt-6 text-[10px] uppercase tracking-[0.3em] text-[#f7e7ce]/30 ff-sans">
          © {new Date().getFullYear()} Pleasure Portal™ — All rights reserved
        </p>
      </div>
    </footer>
  );
}
